export enum HubMethods {
    RetrieveCaMeetingRequestContext = 'RetrieveCaMeetingRequestContext',
    OnCaMeetingRequestContext = 'onCaMeetingRequestContext',
    RetrieveCurrentCaResult = 'retrieveCurrentCaResult',
    OnCaResult = 'onCaResult',
}
